// ===============================
// FINANCIAL AUDIT SOLUTIONS DATA
// ===============================

// 1️⃣ Financial Statement Audit
export const financialStatementAuditHeading = {
  subtitle: "OUR SERVICES",
  title: "COMPREHENSIVE AUDIT SUPPORT THAT BUILDS CONFIDENCE",
  description:
    "We help organizations present clean, reliable statements that stand up to scrutiny from regulators, lenders, and investors.",
};

export const financialStatementAuditData = [
  {
    title: "Financial Accuracy Review",
    text: "We validate every key statement and underlying record to ensure your financials are error-free, consistent, and audit-ready.",
  },
  {
    title: "Internal Controls Evaluation",
    text: "We identify control gaps across processes and systems, helping you strengthen risk mitigation and operational reliability.",
  },
  {
    title: "Compliance & Standards Check",
    text: "We review your practices against IFRS, GAAP, and local regulations to ensure full compliance and avoid reporting penalties.",
  },
  {
    title: "Analytical Insight Reporting",
    text: "We convert financial data into clear insights and trends that support smarter board decisions and better governance.",
  },
];

// 2️⃣ IFRS Advisory Service
export const ifrsAdvisoryServiceHeading = {
  subtitle: "OUR EXPERTISE",
  title: "COMPREHENSIVE IFRS ADVISORY SOLUTIONS",
  description:
    "Our IFRS support eases complex accounting assessments, complete implementation of roadmaps for accurate, transparent, and audit-ready financial reporting.",
};

export const ifrsAdvisoryServiceData = [
  {
    title: "IFRS Implementation",
    text: "Assistance with adopting new or revised IFRS standards, including gap analysis, reporting alignment, and transition support.",
  },
  {
    title: "Complex Accounting Issues",
    text: "Guidance on revenue recognition, leases, financial instruments, consolidation, and fair value measurement.",
  },
  {
    title: "Financial Statement Review",
    text: "Review and refinement of IFRS disclosures to strengthen clarity, accuracy, and regulatory compliance.",
  },
  {
    title: "Training & Capacity Building",
    text: "Tailored IFRS workshops designed to upskill finance teams, enhance reporting quality, and build long-term capability.",
  },
];

// 3️⃣ Other Assurance Service
export const otherAssuranceServiceHeading = {
  subtitle: "OUR SERVICES",
  title: "INDEPENDENT ASSURANCE FOR CRITICAL BUSINESS AREAS",
  description:
    "Our assurance services bring independent evidence to the table, so what you report is trusted, defended, and ready to influence investors, regulators, and partners.",
};

export const otherAssuranceServiceData = [
  {
    title: "Control Strength",
    text: "We test how well your systems actually work; not on paper, but in real workflows, under real pressure, with real risk exposure.",
  },
  {
    title: "Compliance Credibility",
    text: "We verify compliance interpretations, documentation trails, and reporting practices so you face scrutiny with proof.",
  },
  {
    title: "Sustainability Proofing (ESG)",
    text: "We validate ESG statements, performance claims, and emissions data so sustainability communication withstands investor challenge.",
  },
  {
    title: "Reporting Integrity",
    text: "We review KPIs, operational metrics, and management reports to ensure every number presented is accurate and repeatable.",
  },
];

// 4️⃣ Internal Control Framework
export const internalControlFrameworkHeading = {
  subtitle: "INTERNAL CONTROL REINFORCEMENT",
  title: "FRAMEWORKS BUILT TO DETECT & PREVENT",
  description:
    "We don’t just evaluate controls; we rebuild them into systems that stand firm under pressure and scale with growth.",
};

export const internalControlFrameworkData = [
  {
    title: "Control Mapping",
    text: "We decode how work actually moves inside your organization and build a visual blueprint that brings hidden inefficiencies into light.",
  },
  {
    title: "Gap Diagnosis",
    text: "Our experts identify vulnerable touchpoints, manual dependencies, segregation-of-duty conflicts, and fraud-prone zones.",
  },
  {
    title: "Control Design",
    text: "Instead of generic checklists, we craft controls tailored to your workflows, business model and technology maturity.",
  },
  {
    title: "Framework Embedding",
    text: "We help you move beyond documentation toward real adoption and building feedback loops so controls evolve with scale, ERP upgrades or market shifts.",
  },
];

export const dealAdvisoryHeading = {
  subtitle: "STRATEGIC DEAL SUPPORT",
  title: "END-TO-END GUIDANCE ACROSS THE DEAL LIFECYCLE",
  description:
    "We assist throughout buy-side and sell-side transactions — from identifying opportunities to closing value deals.",
};

export const dealAdvisoryData = [
  {
    title: "M&A Advisory",
    text: "Target screening, synergy modelling & deal strategy for smooth integration and maximum long-term gain.",
  },
  {
    title: "Business Valuation",
    text: "Fair value assessments based on financials, market conditions, growth potential, and stakeholder expectations.",
  },
  {
    title: "Due Diligence",
    text: "Financial, commercial, and operational due diligence to validate assumptions, reveal hidden risks, and enable informed decision-making.",
  },
  {
    title: "Divestment Support",
    text: "Exit planning, buyer mapping & capital optimization to ensure you sell at the right time and right value.",
  },
];
export const restructuringHeading = {
  subtitle: "OUR RESTRUCTURING OFFERINGS",
  title: "SOLUTIONS DESIGNED FOR REVIVAL",
  description:
    "Our restructuring support reduces cash burn, unlocks working capital, restores lender confidence, and sets the organization on a path to profitable stability.",
};

export const restructuringData = [
  {
    title: "Debt Realignment",
    text: "We restructure loan terms, redesign repayment, improve borrowing quality, and rebuild lender confidence so your business breathes again.",
  },
  {
    title: "Cost Structure Redesign",
    text: "Not cost-cutting, but cost-engineering. We trim inefficiencies, sharpen resource productivity, and reshape overheads for businesses.",
  },
  {
    title: "Working Capital Fix",
    text: "We unlock the cash stuck inside operations — faster inventory rotation, smarter supplier terms, and treasury control that keeps liquidity flowing.",
  },
  {
    title: "Turnaround Strategy",
    text: "A new market lens, renewed pricing discipline, realigned portfolios, and a go-forward model for a strategic growth momentum.",
  },
];
export const dueDiligenceHeading = {
  subtitle: "WHAT YOU CAN EXPECT",
  title: "DEAL INTELLIGENCE THAT WORKS FOR YOU",
  description:
    "We help buyers, investors, lenders, and acquirers make decisions backed by evidence — not optimism.",
};

export const dueDiligenceData = [
  {
    title: "Financial Integrity Review",
    text: "We verify reported performance, normalize earnings, assess working capital health, and identify revenue-quality gaps hidden under growth numbers.",
  },
  {
    title: "Operational Reality Check",
    text: "We study supply chain resilience, scalability, processes, and execution capability — not just what slide decks claim.",
  },
  {
    title: "Market Position Scrutiny",
    text: "We evaluate competitive standing, customer stickiness, pricing power, churn risk, and real growth outlook - based on market fundamentals.",
  },
  {
    title: "Risk & Exposure Mapping",
    text: "We uncover vulnerabilities in compliance, tax, contracts, litigation, and ESG exposure — ensuring no hidden liability hits later.",
  },
];
export const forensicServicesHeading = {
  subtitle: "OUR FORENSIC CAPABILITIES",
  title: "INVESTIGATION, INSIGHT & LEGAL-READY EVIDENCE",
  description:
    "Tailor-made forensic solutions for uncovering fraud, supporting litigation, resolving disputes & safeguarding business credibility.",
};

export const forensicServicesData = [
  {
    title: "Fraud & Misappropriation Review",
    text: "Tracks fund diversion, ghost vendors, inflated expenses, internal collusion & asset misuse with structured audit trails.",
  },
  {
    title: "Litigation & Dispute Support",
    text: "Evidence-based reports, quantified loss statements & proof documentation admissible for court, arbitration or regulatory review.",
  },
  {
    title: "Digital & Cyber Forensics",
    text: "Log extraction, email tracing, access trail mapping & digital evidence recovery for cyber-enabled financial misconduct.",
  },
  {
    title: "Post-Fraud Recovery Advisory",
    text: "Assistance with recovery strategy, settlement support & strengthening controls to prevent recurrence.",
  },
];
export const riskAdvisoryHeading = {
  subtitle: "OUR SOLUTIONS",
  title: "RISK PREVENTION & RECOVERY CONFIDENCE",
  description:
    "We design frameworks that don’t just react to risks — they anticipate and eliminate them early.",
};

export const riskAdvisoryData = [
  {
    title: "Enterprise Risk Management",
    text: "Building risk governance matrices, reporting pathways, KRIs and escalation protocols for organization-wide resilience.",
  },
  {
    title: "Regulatory & Compliance Risk",
    text: "Gap analysis, compliance mapping, review controls & readiness for local and international regulatory standards.",
  },
  {
    title: "Operational & Process Risk",
    text: "Identification of process failures, internal control weaknesses, fraud exposure & continuity vulnerabilities.",
  },
  {
    title: "Business Continuity Planning",
    text: "Crisis response structures, recovery frameworks, communication protocols & scenario simulation for disruption-readiness.",
  },
];
export const technologyAdvisoryHeading = {
  subtitle: "WHAT WE DELIVER",
  title: "TECH SOLUTIONS THAT SOLVE PROBLEMS",
  description:
    "Technology only matters when it improves productivity or reduces cost. We help organizations adopt digital capabilities that actually move numbers.",
};

export const technologyAdvisoryData = [
  {
    title: "Tech Strategy & Roadmaps",
    text: "We interpret business goals into technology plans that are realistic, scalable, and investment-worthy — not theoretical PDFs.",
  },
  {
    title: "ERP Selection & Implementation",
    text: "We evaluate vendors, negotiate value, build adoption paths, and ensure ERP becomes a growth enabler — not an expensive failure.",
  },
  {
    title: "Cloud Modernization & Infrastructure",
    text: "We move legacy setups to cloud with security, uptime stability, and cost-control as priorities — not just migration for trend.",
  },
  {
    title: "Data Intelligence & Automation",
    text: "We turn scattered data into insights, automate repetitive tasks, and help teams make faster decisions with AI-supported workflows.",
  },
];
export const valuationsHeading = {
  subtitle: "OUR VALUATION SOLUTIONS",
  title: "VALUATION THAT HOLDS WEIGHT",
  description:
    "Valuations built to guide boardrooms, not just fill reports. Each assessment is structured, benchmarked, and future tested.",
};

export const valuationsData = [
  {
    title: "Business Valuation",
    text: "Clarity on enterprise value for mergers, stake sales, PE/VC investment, and restructuring actions.",
  },
  {
    title: "Asset & Securities Valuation",
    text: "Independent valuation of tangible assets, intangible IP, equity, debt, and hybrid instruments.",
  },
  {
    title: "Startup & Early-Stage Valuation",
    text: "Forward-looking valuation based on growth modelling, market traction, unit economics, and scalability.",
  },
  {
    title: "Fairness & Purchase Price Allocation",
    text: "In-depth valuation support during acquisitions ensuring deal prices reflect true worth—not inflated expectations.",
  },
];

// CORPORATE TAX
export const corporateTaxHeading = {
  subtitle: "CORPORATE TAX SOLUTIONS",
  title: "ADVISORY THAT BALANCES SAVINGS & COMPLIANCE",
  description:
    "We support companies through the entire tax lifecycle — from planning, filing and assessments to long-term structuring.",
};

export const corporateTaxData = [
  {
    title: "Tax Strategy & Structuring",
    text: "We design tax-efficient corporate structures, evaluate profit channels, and identify deductible opportunities.",
  },
  {
    title: "Returns, Filing & Compliance Management",
    text: "Corporate returns, disclosures, compliance checks, and documentation handled end-to-end — reducing filing errors.",
  },
  {
    title: "Assessments, Investigation & Defence",
    text: "Complete representation support during notices, audits or disputes — with paperwork for faster resolution.",
  },
  {
    title: "Group Structuring & Expansion Tax Models",
    text: "Advisory for mergers, acquisitions, and cross-border expansion to optimize tax load and future-year exposure.",
  },
];

// MERGER & ACQUISITION
export const mergerAndAcquisitionHeading = {
  subtitle: "BUILT FOR BETTER DEALS",
  title: "TAX SUPPORT ACROSS THE M&A LIFECYCLE",
  description:
    "Every transaction carries tax consequences — some save money, some burn it. We ensure your deal structure is tax-optimized and built to protect long-term value.",
};

export const mergerAndAcquisitionData = [
  {
    title: "Optimized Deal Structuring",
    text: "We structure mergers, acquisitions to minimize leakage, unlock deductions, and improve ROI.",
  },
  {
    title: "Smart Risk Intelligence",
    text: "Deep-dive due diligence to reveal hidden liabilities, tax exposures, transfer pricing gaps & compliance blind spots.",
  },
  {
    title: "Cross-Border Integration",
    text: "Tax planning for global entities, returning routes, holding company setups and treaty-benefit positioning.",
  },
  {
    title: "Seamless Post-Merger Alignment",
    text: "Hands-on integration support, aligning tax books, carrying forward benefits, and entity consolidation.",
  },
];

// TRANSFER PRICING
export const transferPricingHeading = {
  subtitle: "TRANSFER PRICING CAPABILITIES",
  title: "END-TO-END ADVISORY ACROSS POLICY & PROOF",
  description:
    "Every transfer pricing model must be data-driven, and our solutions cover governance, compliance & documentation.",
};

export const transferPricingData = [
  {
    title: "Transfer Pricing Study",
    text: "We analyze functions, assets, risks, and economic realities to build pricing that stands up to scrutiny.",
  },
  {
    title: "Inter-Company Agreement",
    text: "Clear fee logic, risk distribution, and value contribution ensure tax authorities recognize each entity’s economic entitlement.",
  },
  {
    title: "Local + Master File Documentation",
    text: "Documentation that narrates your value chain and prepares you for audits across multiple jurisdictions confidently.",
  },
  {
    title: "Dispute Resolution",
    text: "When authorities challenge your numbers, we provide negotiation support and litigation-ready economic evidence.",
  },
];

// VALUE ADDED TAX
export const valueAddedTaxHeading = {
  subtitle: "VAT SOLUTIONS",
  title: "COMPLIANCE, STRATEGY & ONGOING MANAGEMENT",
  description:
    "We support every VAT touchpoint — setup, filings, interpretation, audits, documentation, and transaction structuring.",
};

export const valueAddedTaxData = [
  {
    title: "VAT Registration & Structuring",
    text: "We assess operations, applicable thresholds, and mixed-supply implications to define the right registration path.",
  },
  {
    title: "Return Filing & Record Management",
    text: "Periodic filings, invoice compliance checks, credit claims, and documentation controls to prevent penalties.",
  },
  {
    title: "VAT Advisory on Deals",
    text: "We advise on cross-border supplies, place-of-supply rules, zero-rating eligibility and reverse charge impact.",
  },
  {
    title: "VAT Audit Support",
    text: "We prepare defense packs, handle authority queries, support clarifications, and negotiate where needed with evidence backing.",
  },
];


// INTERNATIONAL TAX
export const internationalTaxHeading = {
  subtitle: "END-TO-END TAX SUPPORT",
  title: "INTERNATIONAL TAX SOLUTIONS FOR SCALABILITY",
  description:
    "Cross-border growth demands more than expansion—it requires tax foresight and structural accuracy. And we deliver!",
};

export const internationalTaxData = [
  {
    title: "Cross-Border Tax Structuring",
    text: "Group entity planning, inter-company flows, and global holding patterns are modelled for long-term cost efficiency.",
  },
  {
    title: "DTAA & Treaty Optimization",
    text: "We evaluate tax credit eligibility to minimize leakage and ensure every jurisdiction works in your favour.",
  },
  {
    title: "Withholding & Repatriation Planning",
    text: "Moving capital across borders shouldn’t drain returns. Hence, we help with managing fees and IP transfers with compliant mechanisms.",
  },
  {
    title: "Multi-Jurisdiction Compliance",
    text: "We streamline compliance across tax years, countries, and regulators while embedding BEPS, OECD, etc.",
  },
];


// TAX RESTRUCTURING
export const taxRestructuringHeading = {
  subtitle: "OUR RESTRUCTURING OFFERINGS",
  title: "TAX-EFFICIENT SOLUTIONS FOR SUSTAINABLE GROWTH",
  description:
    "Our restructuring solutions eliminate leakage, strengthen compliance & improve post-tax profitability without disrupting core operations.",
};

export const taxRestructuringData = [
  {
    title: "Entity Restructuring",
    text: "We redesign entity layouts, inter-company flows & ownership routes to reduce tax friction and improve net retainable income.",
  },
  {
    title: "Dividend Optimization",
    text: "Tax-efficient dividend routing, interest deductions, equity vs. debt analysis — aligned to reduce payout tax impact.",
  },
  {
    title: "Reclassification Strategies",
    text: "We restructure assets, business verticals & functions to minimize exposure without compliance risk.",
  },
  {
    title: "Post-Restructuring Compliance",
    text: "New structures are monitored continuously — filings, documentation & tax positions stay watertight throughout implementation.",
  },
];

// ECONOMIC SUBSTANCE REGULATIONS
export const economicSubstanceRegulationsHeading = {
  subtitle: "MAKE SUBSTANCE AUDITABLE",
  title: "END-TO-END ESR COMPLIANCE SOLUTIONS",
  description:
    "Our ESR solutions minimise penalties, align activities with substance requirements, and secure regulatory confidence.",
};

export const economicSubstanceRegulationsData = [
  {
    title: "GAP Assessment",
    text: "We evaluate substance gaps across people, activity, decision-making & expenditure to identify filing risks early.",
  },
  {
    title: "Return Filing Support",
    text: "Complete preparation, submission & review of ESR notifications and reports with authoritative narratives.",
  },
  {
    title: "Operating Model Strengthening",
    text: "We help board minutes, CIGA documentation & resource allocation for stronger compliance.",
  },
  {
    title: "Defense Support",
    text: "Representation, documentation packs & response drafting for audits, clarifications and non-compliance evaluations.",
  },
];
// EXCISE TAX
export const exciseTaxHeading = {
  subtitle: "OUR TAX EXPERTISE",
  title: "CLEAR EXCISE TAX FRAMEWORKS & EXECUTION",
  description:
    "We align your business with excise obligations through structured planning, operational review and ongoing compliance support.",
};

export const exciseTaxData = [
  {
    title: "Excise Tax Registration",
    text: "We help you register correctly, set up internal documentation processes that prevent liability disputes down the line.",
  },
  {
    title: "Product Classification",
    text: "Every product attracts a different duty — we classify accurately and ensure rates applied are the lowest legally permissible.",
  },
  {
    title: "Return Filing & Monitoring",
    text: "Excise filings are risk declarations. We prepare, file, and monitor compliance with zero-penalty focus.",
  },
  {
    title: "Representation & Audit Support",
    text: "We defend assessments, respond to notices, prepare audit documentation & represent you confidently before authorities.",
  },
];
export const financeAndAccountingHeading = {
  subtitle: "CASH-SMART BUSINESS SERVICES",
  title: "END-TO-END FINANCE & ACCOUNTING SUPPORT",
  description:
    "Outsourcing with Pestel & Partners means more than bookkeeping, you gain a finance engine that runs smoothly behind your business.",
};
export const financeAndAccountingData = [
  {
    title: "Smart Bookkeeping",
    text: "Daily transactions always recorded with precision. Hence, we keep financial books clean, structured, and always up to date.",
  },
  {
    title: "Insight-Rich Reporting",
    text: "Monthly MIS, KPI performance, and financial statements delivered in business-English, helping leaders see where money moves.",
  },
  {
    title: "Forecasting & Cashflow Modeling",
    text: "We build budget frameworks, monitor burn, and map revenue patterns to help you allocate funds smartly.",
  },
  {
    title: "Compliance-Ready Documentation",
    text: "From month-end to year-end, reports stay audit-ready, tax-ready, and board-ready, so your finance stays compliant.",
  },
];
export const corporateAdvisoryServicesHeading = {
  subtitle: "STRATEGIC SUPPORT",
  title: "CORPORATE ADVISORY FOR REAL BUSINESS",
  description:
    "We don’t just recommend; we rethink the problem, simulate impact, and deliver a course of action designed for measurable financial return.",
};
export const corporateAdvisoryServicesData = [
  {
    title: "Capital Structuring",
    text: "Assess equity vs. debt mix, optimize leverage, and reduce capital costs without disrupting cash flow.",
  },
  {
    title: "Business Expansion Strategy",
    text: "Market entry analysis, pricing blueprint, scalability modelling and partnership frameworks.",
  },
  {
    title: "M&A Feasibility Support",
    text: "Valuation assessment, synergy analysis, post-deal integration roadmap to secure ROI.",
  },
  {
    title: "Board Advisory & Governance",
    text: "Stronger compliance, reporting checks, transparent oversight and strategic execution alignment.",
  },
];
export const expensesClaimManagementHeading = {
  subtitle: "SERVICE BREAKDOWN",
  title: "SYSTEM TO CONTROL, TRACK & VERIFY EXPENSES",
  description:
    "We handle every stage of claim processing, ensuring transparency, policy compliance, and accurate payouts.",
};
export const expensesClaimManagementData = [
  {
    title: "Smart Claim Submission",
    text: "Digital submission with predefined categories and policy prompts to reduce errors and missing data.",
  },
  {
    title: "Policy & Compliance Validation",
    text: "Every claim is checked against organizational policies, tax rules, and documentation standards to prevent financial leakages.",
  },
  {
    title: "Fast Reimbursement Processing",
    text: "Optimised approval workflows that cut reimbursement delays and keep employees satisfied.",
  },
  {
    title: "Real-Time Reporting",
    text: "Clear dashboards showing spending patterns, policy deviations, and cost-saving opportunities.",
  },
];
export const payrollHrServicesHeading = {
  subtitle: "OUR CAPABILITIES",
  title: "A UNIFIED PAYROLL & HR FRAMEWORK",
  description:
    "Our payroll solutions combine accuracy, automation, and compliance to build a stable operational foundation.",
};
export const payrollHrServicesData = [
  {
    title: "Precision Payroll Architecture",
    text: "A fully engineered payroll framework designed to eliminate manual intervention and maintain 100% compliance.",
  },
  {
    title: "Intelligent Workforce Records",
    text: "From digital employee folders to policy governance, your organization gains an organized and secure information ecosystem.",
  },
  {
    title: "Leave & Attendance Management",
    text: "Beyond tracking attendance, we deliver insights that help you understand productivity patterns, resource gaps, and leave cycles.",
  },
  {
    title: "Benefits & Employee Support",
    text: "A streamlined experience platform where employees receive clarity on payslips, policies, entitlements, reimbursements, and benefits.",
  },
];
export const secondmentHeading = {
  subtitle: "OUR SECONDMENT SOLUTIONS",
  title: "FLEXIBLE, RELIABLE TALENT SUPPORT",
  description:
    "Our secondment service goes beyond filling seats. We deploy professionals who bring immediate capability, stabilize operations, and uplift your team’s performance.",
};
export const secondmentData = [
  {
    title: "Capability on Demand",
    text: "We provide secondees for handling compliance cycles and operational surges with precision and ownership.",
  },
  {
    title: "Specialist Support for Projects",
    text: "During ERP shifts, our experts offer technical depth and the extra bandwidth your core team needs to stay on track.",
  },
  {
    title: "Long-Term Workforce Support",
    text: "Fill skill gaps caused by resignations, medical leave, or expansion phases with reliable professionals who ensure stability and consistency.",
  },
  {
    title: "Managed Secondment Oversight",
    text: "We supervise, evaluate, and support our secondees throughout their engagement, ensuring quality output and professionalism.",
  },
];
export const treasuryServiceHeading = {
  subtitle: "OUR CAPABILITIES",
  title: "TREASURY SUPPORT DESIGNED AROUND CASH DISCIPLINE",
  description:
    "We help businesses strengthen liquidity, simplify cash processes, and reduce exposure to financial and operational risks through structured treasury support.",
};
export const treasuryServiceData = [
  {
    title: "Centralized Cash Visibility",
    text: "We establish transparent cash dashboards so leadership can track inflows, outflows, and liquidity positions in real time.",
  },
  {
    title: "Bank Relationship & Transaction Oversight",
    text: "We manage communication, mandates, signatories, and transaction reviews to ensure banking operations remain compliant.",
  },
  {
    title: "Treasury Controls & Risk Monitoring",
    text: "We strengthen your internal control environment through approval workflows, segregation of duties, and fraud-prevention measures.",
  },
  {
    title: "Working Capital Management",
    text: "We provide short-term and long-term cash forecasting models that help businesses plan obligations.",
  },
];
// STRATEGIES
export const marketResearchHeading = {
  subtitle: "OUR CAPABILITIES",
  title: "RESEARCH THAT ADDS DIRECTION",
  description:
    "Every insight we deliver serves a business purpose, like identifying gaps, validating opportunities, benchmarking competition, or shaping go-to-market strategies.",
};

export const marketResearchData = [
  {
    title: "Market & Industry Landscape",
    text: "We interpret weak signals and emerging shifts like consumer sentiment, policy changes, and category disruptions.",
  },
  {
    title: "Customer & Buyer Behaviour",
    text: "Through behavioural audits, wallet-share patterns, and journey friction mapping, we uncover what truly drives conversion and loyalty.",
  },
  {
    title: "Competitor Benchmarking",
    text: "Beyond benchmarking, we study competitor profit pools, strategy pivots, and capability gaps to uncover unserved demand pockets.",
  },
  {
    title: "Market Entry Validation",
    text: "Every idea is evaluated across financial viability, operational readiness, market appetite, and risk exposure.",
  },
];

export const businessConsultingHeading = {
  subtitle: "OUR CONSULTING CAPABILITIES",
  title: "SOLUTIONS DESIGNED FOR SMARTER BUSINESSES",
  description:
    "Every engagement is crafted to diagnose root causes and enable leaders to strengthen performance and accelerate growth with confidence.",
};

export const businessConsultingData = [
  {
    title: "Business Process Re-Engineering",
    text: "We identify inefficiencies hidden inside daily operations and rebuild processes for speed, accuracy, and cost-effectiveness.",
  },
  {
    title: "Financial Performance Improvement",
    text: "Through margin analysis and cost-control frameworks, we help businesses boost profitability without any disruptions.",
  },
  {
    title: "Organizational Structuring & Governance",
    text: "We design structures, decision hierarchies, and governance models that support sustainable, conflict-free growth.",
  },
  {
    title: "Operational Strategy & Efficiency Roadmaps",
    text: "Our consultants build future-ready operational strategies that streamline workflows and reduce redundancy.",
  },
];

// CORPORATE SERVICES
export const entitySetupHeading = {
  subtitle: "OUR INCORPORATION SOLUTIONS",
  title: "ESTABLISH YOUR BUSINESS WITHOUT DELAYS",
  description:
    "From selecting the right jurisdiction to obtaining licenses and drafting corporate documents, we simplify the entire setup journey with precision.",
};

export const entitySetupData = [
  {
    title: "Jurisdiction & Structure Advisory",
    text: "We assess your goals and recommend the most suitable entity type — LLC, branch, representative office, etc.",
  },
  {
    title: "Documentation & Regulatory Compliance",
    text: "All legal docs, filings, and govt. submissions are managed by our experts to ensure smooth, error-free approval.",
  },
  {
    title: "License & Registration Management",
    text: "We coordinate with authorities to secure trade licenses, professional approvals, and operational permits.",
  },
  {
    title: "Post-Incorporation Support",
    text: "Beyond registration, we assist with banking support, compliance onboarding, and governance essentials.",
  },
];

export const outsourcedFinanceRegulatoryComplianceHeading = {
  subtitle: "END-TO-END EXPERTISE",
  title: "FINANCE OPERATIONS MANAGED WITH ZERO GAPS",
  description:
    "What our expertise bring? Structured processes, automated workflows, and domain-led oversight to strengthen your financial accuracy.",
};

export const outsourcedFinanceRegulatoryComplianceData = [
  {
    title: "Real-Time Financial Management",
    text: "Daily bookkeeping, payables, receivables, and month-end closures delivered with precision.",
  },
  {
    title: "Regulatory Filing & Reporting",
    text: "We manage tax submissions, compliance returns, licensing renewals, ESR support, and industry-specific reporting.",
  },
  {
    title: "Internal Controls & Governance Setup",
    text: "We design approval flows, documentation protocols, and financial governance structures that put you in a risk-free zone.",
  },
  {
    title: "Compliance Monitoring & Risk Alerts",
    text: "Ongoing audits, compliance checklists, and early warnings ensure you stay fully aligned with every regulatory requirement.",
  },
];

export const companySecretarialHeading = {
  subtitle: "OUR GOVERNANCE SOLUTIONS",
  title: "SECRETARIAL SUPPORT THAT WORKS PERFECTLY",
  description:
    "A company doesn’t stay compliant by accident; it stays compliant through discipline, structure, and a partner who tracks every detail before it becomes a problem.",
};

export const companySecretarialData = [
  {
    title: "Statutory Records",
    text: "We maintain every register, update every change, and conduct internal audits so your company books remain inspection-ready.",
  },
  {
    title: "Shareholder Meeting Support",
    text: "Smooth governance starts with well-run meetings. We prepare agendas that draft notices and resolutions with legal accuracy.",
  },
  {
    title: "Regulatory Filings & Renewals",
    text: "Every annual return, regulatory update, trade license renewal, etc., is tracked, prepared, and filed before the clock runs out.",
  },
  {
    title: "Corporate Changes & Restructuring",
    text: "We manage director appointments, share transfers, and corporate modifications with accurate documentation.",
  },
];
